import { useMemo } from 'react';
import ForgotPasswordPage from 'Components/auth/ForgotPassword';
import ForgotPasswordPhonePage from 'Components/auth/ForgotPasswordPhone';
import LoginPage from 'Components/auth/Login';
import PasswordSetupPage from 'Components/auth/PasswordSetup';
import ResetPasswordPage from 'Components/auth/ResetPassword';
import SignInPage from 'Components/auth/SignIn';
import VerifyAccountPage from 'Components/auth/VerifyAccount';
import VerifyPhonePage from 'Components/auth/VerifyPhone';
import Consents from 'Components/consents/ConsentsScreen';
import Document from 'Components/consents/Document';
import HipaaConsent from 'Components/consents/HipaaConsent';
import RWEConsent from 'Components/consents/RWEConsent';
import VerifyConsents from 'Components/consents/VerifyConsents';
import LandingPage from 'Components/LandingPage';
import RegisterPage from 'Components/register/CreateNewUser';
import AccountInformation from 'Components/settings/AccountInformation';
import UpdateEmailPage from 'Components/settings/UpdateEmail';
import UpdatePasswordPage from 'Components/settings/UpdatePassword';
import UpdatePhonePage from 'Components/settings/UpdatePhone';
import { InitializationErrorPage } from 'Components/utility/InitializationErrorPage';
import CareTeamConnectionsForm from 'Components/connections/CareTeamConnectionsForm';
import CareTeamConnectionsList from 'Components/connections/CareTeamConnectionsList';

const routes = [
  { route: 'login', component: LoginPage },
  { route: 'create-account', component: RegisterPage },
  { route: 'forgot-password', component: ForgotPasswordPage },
  { route: 'reset-password', component: ResetPasswordPage },
  { route: 'account-information', component: AccountInformation },
  { route: 'update-password', component: UpdatePasswordPage },
  { route: 'hipaa', component: HipaaConsent },
  { route: 'rwe', component: RWEConsent },
  { route: 'terms-of-use', component: Document, props: { type: 'toulibre' } },
  { route: 'privacy-notice', component: Document, props: { type: 'pnlibre' } },
  { route: 'verify-consents', component: VerifyConsents },
  { route: 'consents', component: Consents },
  // CLM routes
  { route: 'sign-in', component: SignInPage },
  { route: 'verify-account', component: VerifyAccountPage },
  { route: 'password-setup', component: PasswordSetupPage },
  { route: 'phone-forgot-password', component: ForgotPasswordPhonePage },
  { route: 'update-phone', component: UpdatePhonePage },
  { route: 'update-email', component: UpdateEmailPage },
  { route: 'verify-phone', component: VerifyPhonePage },
  { route: 'add-connection', component: CareTeamConnectionsForm },
  { route: 'connections', component: CareTeamConnectionsList },
] as const;

const useRouter = ({
  location,
  initErrorStatus,
}: {
  location: string;
  initErrorStatus?: number;
}) => {
  const Component = useMemo(() => {
    if (initErrorStatus) {
      return <InitializationErrorPage errorStatus={initErrorStatus} />;
    }

    const lowerCaseLocation = location.toLowerCase();

    const route = routes.find((r) => lowerCaseLocation.startsWith(`/${r.route.toLowerCase()}`));

    if (route) {
      if ('props' in route) {
        return <route.component {...route.props} />;
      }

      return <route.component />;
    }

    // Fallback to LandingPage if no route matches
    return <LandingPage />;
  }, [initErrorStatus, location]);

  return Component;
};

export default useRouter;
